import {
  createBrowserObservability,
  defineEvent,
  reportBrowserRuntimeError,
} from "@diverge/observability/browser";

const backendUrl = import.meta.env.VITE_BACKEND_URL?.replace(/\/$/, "") || "";
export const dashboardObservability = createBrowserObservability({
  serviceName: "dashboard",
  serviceVersion: import.meta.env.VITE_APP_VERSION || "unknown",
  environment: import.meta.env.VITE_DEPLOYMENT_ENVIRONMENT || "unknown",
  report: async (record) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4500);
    try {
      // The report transport owns no application error handler or auth recovery;
      // delivery failures are counted by the bounded exporter, never re-reported.
      const response = await fetch(`${backendUrl}/api/v1/errors/report`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        signal: controller.signal,
        body: JSON.stringify({
          chatbot_id: record.attributes["di.chatbot_id"],
          error_message: record.body,
          error_details: { log_record: record },
          stack_trace: record.attributes["exception.stacktrace"] || null,
          error_category: "UNKNOWN_ERROR",
        }),
      });
      if (!response.ok) throw new Error("Application event delivery failed");
    } finally {
      clearTimeout(timeout);
    }
  },
});

export const detailEvents = {
  stale: defineEvent({
    name: "dashboard.conversation.sync_failed",
    message: "Conversation updates delayed",
    level: "warn",
    classification: "operational",
    volume: "boundary",
    owner: "dashboard/conversations",
    attributes: {},
  }),
  recovered: defineEvent({
    name: "dashboard.conversation.sync_recovered",
    message: "Conversation synchronization recovered",
    level: "info",
    classification: "operational",
    volume: "boundary",
    owner: "dashboard/conversations",
    attributes: {},
  }),
};

/** Terminal handler for background work whose caller cannot await it. */
export function reportBackgroundError(error: unknown): void {
  reportBrowserRuntimeError(dashboardObservability, error, "unhandled_rejection");
}
